import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { LoadingContainer, Space } from '@redlink/components/atoms';
import { ReportSummaryItem } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';
import { useMoneyMask } from '@redlink/core';
import { useQuery, getReportSummaryQuery } from '@redlink/services';

export const SummaryBlock = memo(() => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();
  const { getValue } = useMoneyMask();

  const {
    loading,
    data: {
      ReportSummary: {
        userCount = 0,
        userCountChange = 0,
        proUserCount = 0,
        proUserCountChange = 0,
        income = 0,
        todayIncome = 0,
        todayIncomeChange = 0,
      } = {},
    },
  } = useQuery(getReportSummaryQuery);

  return (
    <LoadingContainer isBusy={loading} style={styles.summariesContainer}>
      <ReportSummaryItem
        title={dictionary.usersCount}
        value={userCount}
        change={userCountChange}
        style={styles.itemContainer}
        valueFormatter={(value) => getValue(value)}
      />
      <Space />
      <ReportSummaryItem
        title={dictionary.proUsersCount}
        value={proUserCount}
        change={proUserCountChange}
        style={styles.itemContainer}
        valueFormatter={(value) => getValue(value)}
      />
      <Space />
      <ReportSummaryItem
        title={dictionary.income}
        valuePostfix={dictionary.toman}
        value={income / 10}
        changePostfix="%"
        valueFormatter={(value) => getValue(value)}
        style={styles.itemContainer}
      />
      <Space />
      <ReportSummaryItem
        title={dictionary.todayIncome}
        valuePostfix={dictionary.toman}
        value={todayIncome / 10}
        change={todayIncomeChange / 10}
        changePostfix="%"
        valueFormatter={(value) => getValue(value)}
        style={styles.itemContainer}
      />
    </LoadingContainer>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  summariesContainer: {
    flexDirection: 'row',
    minHeight: 110,
  },
  itemContainer: {
    flex: 1,
  },
}));
